// removed by extract-text-webpack-plugin
module.exports = {"root":"IconEnquiry__root__1SekL","marketplaceColorStroke":"IconEnquiry__marketplaceColorStroke__3xZAT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IconEnquiry/IconEnquiry.css
// module id = 1840
// module chunks = 0